import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICreateScheduleForm } from "@src/types/schedules";

interface ScheduleState {
  createEventForm: ICreateScheduleForm;
  isUpdateEventForm: boolean;
  updateEventForm: ICreateScheduleForm & { scheduleId: string };
}

export const scheduleInitialState: ScheduleState = {
  createEventForm: {
    showId: "",
    startTime: "",
    endTime: "",
    playlistId: "",
    moodId: "",
  },
  isUpdateEventForm: false,
  updateEventForm: {
    showId: "",
    startTime: "",
    endTime: "",
    playlistId: "",
    moodId: "",
    scheduleId: "",
  },
};

const playlistSlice = createSlice({
  name: "scheduleSlice",
  initialState: scheduleInitialState,
  reducers: {
    setCreateEventForm(
      state,
      action: PayloadAction<Partial<ScheduleState["createEventForm"]>>
    ) {
      state.isUpdateEventForm = false;
      state.createEventForm = {
        ...state.createEventForm,
        ...action.payload,
      };
    },
    setUpdateEventForm(
      state,
      action: PayloadAction<Partial<ScheduleState["updateEventForm"]>>
    ) {
      state.isUpdateEventForm = true;
      state.updateEventForm = {
        ...state.updateEventForm,
        ...action.payload,
      };
    },
    resetUpdateEventForm(state) {
      state.updateEventForm = scheduleInitialState.updateEventForm;
    },
    resetCreateEventForm(state) {
      state.createEventForm = scheduleInitialState.createEventForm;
    },
  },
});

export const {
  setCreateEventForm,
  setUpdateEventForm,
  resetUpdateEventForm,
  resetCreateEventForm,
} = playlistSlice.actions;

export default playlistSlice.reducer;
